import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route,Switch } from 'react-router-dom';
import Layout from '../../../Layout/index';

import AssetsDashboard from '../../../Dashboards/Assets/index';

class Home extends Component {
  render() {
    const { token } = this.props;
    return (
      <div>
        <Layout />
        <div className="container__wrap">
          <Route path="/" component={AssetsDashboard} />
        </div>
      </div>
    );
  }
}

function mapStateToProps({ token }) {
  return {
    token
  };
}

export default connect(mapStateToProps, null)(Home);